import { Component, h, Method } from '@stencil/core';

@Component({
  tag: 'modal-confirm',
  shadow: false,
  styleUrl: 'modal-confirm.css',
  assetsDirs: ['assets'],
})
export class ModalConfirm {
  modalElement: HTMLDivElement;
  bootstrapModal: any;

  componentDidLoad() {
    this.bootstrapModal = new (window as any).bootstrap.Modal(this.modalElement);
  }

  @Method()
  async show() {
    console.log('show modal', this.bootstrapModal);
    if (this.bootstrapModal) {
      this.bootstrapModal.show();
    }
  }

  @Method()
  async hide() {
    console.log('hide modal', this.bootstrapModal);
    if (this.bootstrapModal) {
      this.bootstrapModal.hide();
    }
  }

  @Method()
  async send() {
    console.log('send modal', this.bootstrapModal);
    if (this.bootstrapModal) {
      this.bootstrapModal.hide();
      //agregar la lógica para enviar la información
      console.log('Información enviada');
    }
  }

  render() {
    return (
      <div
        class="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
        ref={el => (this.modalElement = el as HTMLDivElement)}
      >
        <div class="modal-dialog">
          <div class="modal-content text-center">
            <div class="modal-header bg-primary-light">
              <h1 class="modal-title fs-5 fw-bold" id="staticBackdropLabel">
                Confirmar envío de información
              </h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => this.hide()}></button>
            </div>
            <div class="modal-body fw-medium">
              ¿Esta seguro de finalizar este formulario? <br /> Esta acción ya no podrá revertirse.
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger text-white" data-bs-dismiss="modal" aria-label="Close">
                <i class="bi bi-x-circle me-1"></i>
                Cancelar
              </button>
              <button type="button" class="btn btn-success text-white" onClick={() => this.send()}>
                <i class="bi bi-check-circle me-1"></i>
                Confirmar
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
